const toggleUserMenu = () => ({
    type: 'TOGGLE_USER_MENU',
});

export default toggleUserMenu;
